import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class StarRatingNavigation extends KeyboardNavigation {
    variableIds =
        this.question?.parent?.columns?.flatMap((column) =>
            column.variables?.map((variable) => variable.id),
        ) || [];

    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        if (this.isHybridGrid && (eventKey === "ArrowLeft" || eventKey === "ArrowRight")) {
            return this.findNextFocusableElementWithinSameVariableCommonForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        if (this.isHybridGrid && (eventKey === "ArrowDown" || eventKey === "ArrowUp")) {
            return this.findNextFocusableElementWithinSameVariableCommonForSwitchingRowsForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        let isRowChanged = false;
        let nextVariableId = currentElement.variableId;
        const currentVariableIndex = this.variableIds.indexOf(currentElement.variableId);
        const isLastRowInVariable = currentVariableIndex === this.variableIds.length - 1;

        if (eventKey === "ArrowDown" && isLastRowInVariable) {
            return null;
        }

        if (
            eventKey === "ArrowDown" &&
            currentVariableIndex !== -1 &&
            currentVariableIndex < this.variableIds.length - 1
        ) {
            nextVariableId = this.variableIds[currentVariableIndex + 1];
        } else if (eventKey === "ArrowUp" && currentVariableIndex > 0) {
            nextVariableId = this.variableIds[currentVariableIndex - 1];
            isRowChanged = true;
        }

        if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
            for (let i = index; i < this.defaultFocusStatus.statuses.length; i++) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === nextVariableId &&
                    elementFocusStatus.elementId !== currentElement.elementId
                ) {
                    return elementFocusStatus;
                }
            }
        } else if (eventKey === "ArrowUp") {
            if (!isRowChanged) return null;

            const previousRowFirstElementIndex = this.defaultFocusStatus.statuses.findIndex(
                (el) => el.variableId === nextVariableId,
            );
            for (
                let i = previousRowFirstElementIndex;
                i < this.defaultFocusStatus.statuses.length;
                i++
            ) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === nextVariableId &&
                    elementFocusStatus.elementId !== currentElement.elementId
                ) {
                    return elementFocusStatus;
                }
            }
        } else if (eventKey === "ArrowLeft") {
            for (let i = index; i >= 0; i--) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];
                if (
                    elementFocusStatus.variableId === nextVariableId &&
                    elementFocusStatus.elementId !== currentElement.elementId
                ) {
                    return elementFocusStatus;
                }
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        if (this.isHybridGrid) {
            return this.findNextFocusableElementWithinNextVariableCommonForHybridGrid(
                currentElement,
            );
        }
        return this.findNextFocusableElementWithinNextVariableCommon(
            currentElement,
            this.variableIds,
        );
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findLastFocusableElementWithinPreviousVariableCommon(
            currentElement,
            this.variableIds,
        );
    }
}
